import PropTypes from 'prop-types'
import React, { Fragment, useState, useEffect } from 'react'
import { useDebounce } from 'base/lib/custom_hooks'
import classNames from 'classnames'
import { EverlaneLink } from 'base/components/router_link'
import Event from 'base/event'
import Hub from 'base/hub'
import DropdownMenuV2 from 'desktop/components/layout/dropdown_menu_v2'
import setEvents from './menu_helpers'

const defaultEventProperties = {
  type: 'text',
  placement: 'top',
}

function Subheader({ categories, subheaderHeight, hidden, selectedHeaderMenuItem }) {
  const [hoveredCategory, setHoveredCategory] = useState({})
  const [dropdownContentVisible, setDropdownContentVisible] = useState(false)
  const desktopMenuCategories = categories?.filter(category => category?.platform !== 'mobile')

  const debouncedHoveredCategory = useDebounce(hoveredCategory, 120)
  let shopAllUrl = null

  if (selectedHeaderMenuItem === 'Men') {
    shopAllUrl = '/collections/mens-all'
  } else if (selectedHeaderMenuItem === 'Women') {
    shopAllUrl = '/collections/womens-all'
  }

  useEffect(() => {
    Hub.sub(Event.App.ROUTE, () => {
      setHoveredCategory({})
      setDropdownContentVisible(false)
    })
  }, [])

  useEffect(() => {
    if (debouncedHoveredCategory.permalink) {
      setEvents({
        ...defaultEventProperties,
        eventName: Event.Navigation.DROP_DOWN_OPENED,
        name: debouncedHoveredCategory.text,
        url: debouncedHoveredCategory.permalink,
      })
    }

    if (
      debouncedHoveredCategory.sections?.length > 0 ||
      debouncedHoveredCategory.images?.length > 0
    ) {
      setDropdownContentVisible(true)
    } else {
      setDropdownContentVisible(false)
    }
  }, [
    debouncedHoveredCategory,
    debouncedHoveredCategory.permalink,
    debouncedHoveredCategory.text,
    debouncedHoveredCategory.sections,
    debouncedHoveredCategory.images,
  ])

  return (
    <Fragment>
      <nav
        className="app-subheader"
        style={{
          height: subheaderHeight,
          visibility: hidden ? 'hidden' : 'visible',
        }}
      >
        <ul
          className="app-subheader__category-container"
          onMouseLeave={() => setHoveredCategory({})}
        >
          {desktopMenuCategories?.map((category, index) => (
            <li
              key={`${category.permalink}-${index}`}
              className="app-subheader__category-link"
              onMouseEnter={() => setHoveredCategory(category)}
            >
              <EverlaneLink
                href={category.permalink}
                style={{ color: category.color || '#161912' }}
                className={classNames('app-subheader__category-link-text', {
                  'app-subheader__category-link-text--active':
                    debouncedHoveredCategory.text === category.text,
                })}
                onClick={() =>
                  setEvents({
                    ...defaultEventProperties,
                    eventName: Event.Navigation.LINK_CLICK,
                    name: category.text,
                    url: category.permalink,
                  })
                }
              >
                {category.text}
              </EverlaneLink>

              {(category.sections?.length > 0 || category.images?.length > 0) && (
                <DropdownMenuV2
                  key={`${category.permalink}-${index}`}
                  category={category}
                  visible={
                    debouncedHoveredCategory.permalink === category.permalink &&
                    debouncedHoveredCategory.text === category.text &&
                    dropdownContentVisible
                  }
                />
              )}
            </li>
          ))}
          {shopAllUrl && (
            <li key="shop-all" className="app-subheader__category-link">
              <EverlaneLink
                href={shopAllUrl}
                className={classNames('app-subheader__category-link-text', {
                  'app-subheader__category-link-text--active':
                    debouncedHoveredCategory.text === 'Shop All',
                })}
                onMouseEnter={() => {
                  setHoveredCategory({ text: 'Shop All' })
                  setEvents({
                    ...defaultEventProperties,
                    eventName: Event.Navigation.DROP_DOWN_OPENED,
                    name: 'Shop All',
                    url: shopAllUrl,
                  })
                }}
                onMouseLeave={() => setHoveredCategory({})}
                onClick={() =>
                  setEvents({
                    ...defaultEventProperties,
                    eventName: Event.Navigation.LINK_CLICK,
                    name: 'Shop All',
                    url: shopAllUrl,
                  })
                }
              >
                Shop All
              </EverlaneLink>
            </li>
          )}
        </ul>
      </nav>
    </Fragment>
  )
}

Subheader.propTypes = {
  categories: PropTypes.array,
  subheaderHeight: PropTypes.number.isRequired,
  hidden: PropTypes.bool.isRequired,
  selectedHeaderMenuItem: PropTypes.string,
}

export default Subheader
